// ──────────────────────────────────────────────
// IDs centralizados — NUNCA hardcodear IDs en componentes
// ──────────────────────────────────────────────

// Socios / dueños de la plataforma
export const ADMIN_IDS = [1, 4];

// Inversores con acceso restringido (solo lectura parcial).
// Vacío: 1623/1624 pasaron a rol broker (su denylist los bloqueaba de ventas-detalle/proyección,
// sus vistas principales). Los inversores reales (1525, 1572) nunca estuvieron acá.
// La constante se mantiene porque App.js y menuConfig.js la importan como deniedIds.
export const INVERSORES_RESTRINGIDOS = [];

// Usuarios que ven todas las ventas en reporte fotográfico
export const USERS_ALL_VENTAS = [1, 4, 7, 306, 904];

// Usuarios con acceso a galería como admin (pueden subir/borrar)
export const GALERIA_ADMIN_IDS = [1, 4, 904];

// Usuarios que pueden cambiar demo en admin
export const DEMO_SWITCH_IDS = [306, 904];

// Usuarios con acceso a la sección Región
export const REGION_IDS = [1, 4, 7, 306, 749, 750, 751, 752];

// Usuarios con acceso a mailing
export const MAILING_IDS = [1, 4];

// Ejecutivos sin comisión (Chile, 2025+)
export const SIN_COMISION_2025 = [1, 4, 904];

// Agencias de venta directa (0% comisión intermediario)
export const AGENCIAS_DIRECTAS = [16, 32, 60];

// Fecha de activación de la comisión de broker (2ª capa de intermediación).
// Constante dura del gate: ninguna venta anterior a esta fecha lleva broker,
// con independencia de lo que diga el registro del intermediario (gate redundante).
export const BROKER_ACTIVACION = "2026-06-01";

// Equipo OMNET (negociación especial)
export const OMNET_IDS = [1295, 1296, 1297];

// Edificios excluidos de inventario operativo
export const EDIFICIOS_EXCLUIDOS = [119, 121, 157, 158, 159, 168];

// ──────────────────────────────────────────────
// Helpers
// ──────────────────────────────────────────────
export const isAdmin = (id) => ADMIN_IDS.includes(Number(id));
export const isInversorRestringido = (id) => INVERSORES_RESTRINGIDOS.includes(Number(id));
